import "./cartPage.scss";
import { ReactComponent as Plus } from "../../assets/plus.svg";
import { ReactComponent as Minus } from "../../assets/minus.svg";
import { ReactComponent as Right } from "../../assets/right.svg";
import { ReactComponent as Left } from "../../assets/left.svg";
import { ReactComponent as Delete } from "../../assets/delete.svg";
import { products } from "../../utiles/types";
import { useAppDispatch, useAppSelector } from "../../app/hook";
import { formatToCurrency } from "../../utiles/utiles";
import { decrementCartQuantity, incrementCartQuantity, updateCartColor, updateCartSize } from "../../features/productSlice";
import { Link } from "react-router-dom";
import { useState } from "react";

const SingleCartItem = ({
    product,
    setDelete,
    setItemToBeDeleted,
}: {
    product: products;
    setDelete: (value: boolean) => void;
    setItemToBeDeleted: (value: number) => void;
}) => {
    const { productName, image, price, type, sizes, colors, productID, imagePreviews } = product;

    const cart = useAppSelector((state) => state.shop.cart);
    const currentCurrency = useAppSelector((state) => state.shop.currency);
    const CartValueForProduct = cart.find((cart) => cart.productID === productID);

    const [previewIndex, setPreviewIndex] = useState<number>(0);
    const prevSlide = previewIndex === 0 ? imagePreviews.length - 1 : previewIndex - 1;
    const nextSlide = previewIndex === imagePreviews.length - 1 ? 0 : previewIndex + 1;

    const dispatch = useAppDispatch();

    return (
        <div className="c">
            <div className="c_details">
                <Link to={`/product/${productID}`} className="c_details_title">
                    {productName}
                </Link>
                <div className="c_details_category">{type}</div>

                <div className="c_details_price">{formatToCurrency(currentCurrency.currency, price)}</div>

                <div className="c_details_sizes">
                    <div className="c_details_sizes_title condensed_title">sizes:</div>
                    <div className="c_details_sizes_list">
                        {sizes.map((size) => (
                            <button
                                key={size}
                                title="product size"
                                aria-label="product size"
                                className={
                                    size === CartValueForProduct?.selectedSize ? "p_details_sizes_list_selected" : undefined
                                }
                                onClick={() => dispatch(updateCartSize({ productID, size }))}
                            >
                                {size}
                            </button>
                        ))}
                    </div>
                </div>

                <div className="c_details_colors">
                    <div className="c_details_colors_title condensed_title">Colors:</div>
                    <div className="c_details_colors_list">
                        {colors.map(({ code, color }) => (
                            <button
                                key={color}
                                title={color}
                                aria-label={color}
                                className={
                                    color === CartValueForProduct?.selectedColor ? "p_details_colors_list_selected" : undefined
                                }
                                onClick={() => dispatch(updateCartColor({ productID, color }))}
                            >
                                <span style={{ background: code }} />
                            </button>
                        ))}
                    </div>
                </div>
            </div>

            <div className="c_image">
                <div className="c_image_count">
                    <button
                        title="Add quntity"
                        aria-label="Add quntity"
                        onClick={() => dispatch(incrementCartQuantity(productID))}
                    >
                        <Plus />
                    </button>
                    <div>{CartValueForProduct?.quantity}</div>
                    <button
                        title="minus quntity"
                        aria-label="minus quntity"
                        onClick={() => dispatch(decrementCartQuantity(productID))}
                    >
                        <Minus />
                    </button>
                </div>

                <div className="c_image_preview">
                    <img src={imagePreviews[previewIndex]} />
                    <div className="c_image_remove">
                        <button
                            title="previous slide"
                            aria-label="previous slide"
                            onClick={() => {
                                setItemToBeDeleted(productID);
                                setDelete(true);
                            }}
                        >
                            <Delete />
                        </button>
                    </div>
                    <div className="c_image_slide">
                        <button title="previous slide" aria-label="previous slide" onClick={() => setPreviewIndex(prevSlide)}>
                            <Left />
                        </button>
                        <button title="Next slide" aria-label="Next slide" onClick={() => setPreviewIndex(nextSlide)}>
                            <Right />
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default SingleCartItem;
